export default [
  { to: '/tasks/batches', display: 'Task batches', contributorsAllowed: true },
  { to: '/tasks/list', display: 'All tasks' },
  { to: '/tasks/processes', display: 'Process' },
  { to: '/tasks/workflows', display: 'Workflows' },
  { to: '/tasks/contributors', display: 'Statistics', contributorsAllowed: true },
  { to: '/tasks/pages-sampling', display: 'Page sampling', contributorsAllowed: false },
];
